import { useContext } from "react";
import { GlobalDataContext } from "../../providers/GlobalDataProvider";

export default function CustomerSection() {
  const { state } = useContext(GlobalDataContext)

  return (
    <section className="container bg-main flex lg:flex-row flex-row-reverse w-full text-white my-8 gap-6 py-12">
      <div className="hidden lg:flex justify-center items-center">
        <img width={100} height={100}
          src="/images/soop.webp"
          alt="Customer Service"
          className="p-4 size-48 xl:size-72 rounded-full object-cover"
        />
      </div>

      <div dir="rtl" className="flex-1 flex gap-6 flex-col lg:pr-10 px-4">
        <span className="h1">سوالی دارید؟</span>

        <p className="lg:text-xl max-w-2xl">
          هنوز شک دارید که کدوم اثر هنری رو انتخاب کنید؟  نیاز به مشاوره در مورد جنس تابلو‌ها یا ثبت سفارش دارید؟
          <br />
          <br />
          کارشناسان "تونالیته" خوشحال می‌شوند به شما کمک کنند
        </p>

        <div className="flex flex-col gap-2">
          <p className="flex items-center gap-2">
            تلفن: {state.phone}
          </p>

          <p className="flex items-center gap-2">
            ایمیل: {state.email}
          </p>
        </div>
      </div>

      <div className="hidden lg:flex items-center justify-center lg:w-[260px] lg:h-[126px] w-[130px] h-[63px] overflow-hidden mr-4 my-auto">
        <img
          src="/images/Tonaliteh logo.png"
          width={100} height={100}
          alt="Tonaliteh"
          className="w-full h-auto py-2 object-contain opacity-20"
        />
      </div>
    </section>
  );
}
